import { useState, useEffect, useRef, useMemo, useCallback  } from 'react';
import { Dialog, DialogContent, DialogActions, DialogTitle, Button, Grid2, Grid, Box, CardMedia, IconButton, FormControl } from '@mui/material'
import { Form, Formik, Field } from 'formik';
import * as Yup from 'yup';
import MyTextInput from '../../../components/inputs/MyTextInput';
import MyNumberInput from '../../../components/inputs/MyNumberInput';
import MyAutoCompleteJavier from '../../../components/inputs/MyAutoCompleteJavier';
import MyAutoComplete from '../../../components/inputs/MyAutoComplete';
import MyDateTimePicker from '../../../components/inputs/MyDateTimePicker';
import DieselTankSlider from '../../Diesel/fuelUp/components/DieselTankSlider.jsx';
import { myApi } from '../../../config/axiosConfig';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import axios from 'axios';
import moment from 'moment-timezone';

import DeleteIcon from "@mui/icons-material/Delete";
import { ConstructionOutlined } from '@mui/icons-material';

function CrearEditarLoves({ open, onClose, refresh, carga, isEditing, isDividing, isMoving }) {

    const validationSchema = Yup.object({
        unit: Yup.string().required('El número de unidad es obligatorio'),

        cliente: Yup.string().required('El cliente es obligatorio'),
    });

    const initialValues = 
    isMoving
    ? {
        unit: '',
        cliente: '',
        grupo: 'TRACTORES',
        usuario: Cookies.get('ebt_nombre')
    }
    : 
    {
        
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        
        const payload = {  
            unit: values.unit,
            cliente: values.cliente,
            grupo: values.grupo,
            usuario: values.usuario
        };


        try 
        {
            if (isMoving) 
            {
                let responseMover = await myApi.put(`/cargasFuel/moverLoves/${carga.id}`, payload);

                if(responseMover.data.success)
                {
                    Swal.fire({
                        icon: 'success',
                        title: 'Carga movida',
                    });
                    refresh();
                    onClose();
                }
                else
                {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error al mover carga',
                        text: responseMover.data.data || 'Ocurrió un error desconocido',
                        target: document.getElementById('dialog1')
                    });

                    console.error('Error de API:', responseMover.data);
                }
            } 
        } 
        catch (error) 
        {
            Swal.fire({
                icon: 'error',
                title: 'Error del servidor',
                text: error.response?.data?.message || error.message || 'Ocurrió un error desconocido',
            });
            console.error('Error saving charge:', error);
        }
    };

    const [tractoresEBT, setTractoresEBT] = useState([]);
    const [tractoresTEDEL, setTractoresTEDEL] = useState([]);
    const [cajasEBT, setCajasEBT] = useState([]);
    const [cajasTEDEL, setCajasTEDEL] = useState([]);

    const fetchAllUnidades = useCallback(async () => 
    {
        const statuses = ['A', 'I', 'S'];
        const companies = ['EBT', 'TEDEL'];

        try {
            const tractorRequests = companies.flatMap(company =>
                statuses.map(status =>
                    axios.post(
                        'https://apigeneral.ebtapps.com/general/api/mcleod/trucks/',
                        { company, status, tractor: null }
                    )
                )
            );

            const cajaRequests = companies.flatMap(company =>
                statuses.map(status =>
                    axios.post(
                        'https://apigeneral.ebtapps.com/general/api/mcleod/trailers/',
                        { company, status, trailer: null }
                    )
                )
            );

            const [tractorResponses, cajaResponses] = await Promise.all([
                Promise.all(tractorRequests),
                Promise.all(cajaRequests)
            ]);

            const tractoresRaw = tractorResponses.flatMap(r => r.data);
            const cajasRaw = cajaResponses.flatMap(r => r.data);

            const tractoresEBT = new Map();
            const tractoresTEDEL = new Map();
            const cajasEBT = new Map();
            const cajasTEDEL = new Map();

            tractoresRaw.forEach(t => {
                if (!t.tractor) return;

                const item = { value: t.tractor, label: t.tractor };

                if (t.company === 'EBT') {
                    tractoresEBT.set(t.tractor, item);
                } else if (t.company === 'TEDEL') {
                    tractoresTEDEL.set(t.tractor, item);
                }
            });

            cajasRaw.forEach(c => {
                if (!c.trailer) return;

                const item = { value: c.trailer, label: c.trailer };

                if (c.company === 'EBT') {
                    cajasEBT.set(c.trailer, item);
                } else if (c.company === 'TEDEL') {
                    cajasTEDEL.set(c.trailer, item);
                }
            });

            setTractoresEBT([...tractoresEBT.values()]);
            setTractoresTEDEL([...tractoresTEDEL.values()]);
            setCajasEBT([...cajasEBT.values()]);
            setCajasTEDEL([...cajasTEDEL.values()]);

        } catch (error) {
            console.error('Error cargando unidades', error);
        }
    }, []);

    useEffect(() => {
        fetchAllUnidades();
    }, [fetchAllUnidades]);

    const isOnlyDividing = isDividing && !isEditing && !isMoving;
    const isOnlyMoving = isMoving && !isEditing && !isDividing;

    return (
        <Dialog id="dialog1" open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>{
  isDividing
    ? 'Dividir Carga de API de LOVES'
    : isMoving
    ? 'Mover Carga de API de LOVES'
    : isEditing
      ? 'Editar Carga Manual de LOVES'
      : 'Crear Carga Manual de LOVES'
}</DialogTitle>
            <DialogContent>
                <Formik
                    initialValues={{
                        ...initialValues,
                        isDividing,
                    }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    context={{ isDividing, isMoving, isEditing }}
                >
                    {({ isSubmitting, handleSubmit, errors, touched, values, setFieldValue }) => {

                        const catalog =
                            values.grupo === 'TRACTORES' && values.cliente?.includes('EBT')
                                ? tractoresEBT
                                : values.grupo === 'TRACTORES' && values.cliente?.includes('TEDEL')
                                ? tractoresTEDEL
                                : values.grupo === 'CAJAS' && values.cliente?.includes('EBT')
                                ? cajasEBT
                                : values.grupo === 'CAJAS' && values.cliente?.includes('TEDEL')
                                ? cajasTEDEL
                                : [];

                    return (
                        <Form onSubmit={handleSubmit} style={{ width: '100%' }}>
                            <Grid2 container spacing={2}>
                                {!isOnlyDividing && !isOnlyMoving &&(
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <MyDateTimePicker
                                        name="fecha"
                                        label="FECHA"
                                        error={touched.fecha && Boolean(errors.fecha)}
                                        helperText={touched.fecha && errors.fecha}
                                    />
                                    {errors.fecha && touched.fecha ? (
                                        <div style={{ color: '#D3302F', fontSize: '12px' }}>{errors.fecha}</div>
                                    ) : null}
                                </Grid2>
                                )}
                                {!isOnlyDividing && !isOnlyMoving &&(
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <MyAutoComplete
                                        name="grupo"
                                        label="GRUPO"
                                        options={[
                                            { value: 'TRACTORES', label: 'TRACTORES' },
                                            { value: 'CAJAS', label: 'CAJAS' },
                                        ]}
                                        onChange={() => setFieldValue('unit', null)}
                                    />
                                </Grid2>
                                )}
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <MyAutoComplete
                                        name="cliente"
                                        label="CLIENTE"
                                        options={[
                                            { value: 'EBT FREIGHT SA DE CV', label: 'EBT FREIGHT SA DE CV' },
                                            { value: 'TEDEL TRUCKING SA DE CV', label: 'TEDEL TRUCKING SA DE CV' },
                                        ]}
                                        onChange={() => setFieldValue('unit', null)}
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <MyAutoCompleteJavier
                                        name="unit"
                                        label="UNIDAD"
                                        options={catalog} 
                                        key={`noeconomico-${values.grupo}-${values.unit}`} 
                                    />
                                </Grid2>
                                {!isOnlyDividing && !isOnlyMoving && (
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <MyNumberInput
                                        name="consumoPesos"
                                        label="CONSUMO EN PESOS"
                                    />
                                </Grid2>
                                )}
                                {!isOnlyMoving && (
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <MyNumberInput
                                        name="consumoLitros"
                                        label="CONSUMO EN LITROS"
                                    />
                                </Grid2>
                                )}
                                {!isOnlyDividing && !isOnlyMoving &&(
                                <Grid2 size={{xs: 12, sm: 4}}>
                                    <MyTextInput
                                        name="orden"
                                        label="ORDEN"
                                    />
                                </Grid2>
                                )}
                                {!isOnlyDividing && !isOnlyMoving &&(
                                <Grid2 size={{xs: 12, sm: 4}}>
                                    <MyTextInput
                                        name="ubicacion"
                                        label="UBICACIÓN"
                                    />
                                </Grid2>
                                )}
                                {!isOnlyDividing && !isOnlyMoving &&(
                                <Grid2 size={{xs: 12, sm: 4}}>
                                    <MyTextInput
                                        name="destino"
                                        label="DESTINO"
                                    />
                                </Grid2>
                                )}
                                {!isOnlyDividing && !isOnlyMoving &&(
                                <Grid2 size={{xs: 12, sm: 12}}>
                                    <FormControl fullWidth>
                                        <Field name="nivelDiesel">
                                            {({ field }) => (
                                            <DieselTankSlider
                                                label="Nivel de Diésel"
                                                value={values.nivelDiesel}
                                                onChange={(newValue) => {
                                                const valueToLabelMap = {
                                                    0: "EMPTY",
                                                    1: "1/16",
                                                    2: "1/8",
                                                    3: "3/16",
                                                    4: "1/4",
                                                    5: "5/16",
                                                    6: "3/8",
                                                    7: "7/16",
                                                    8: "1/2",
                                                    9: "9/16",
                                                    10: "5/8",
                                                    11: "11/16",
                                                    12: "3/4",
                                                    13: "13/16",
                                                    14: "7/8",
                                                    15: "15/16",
                                                    16: "FULL",
                                                };
                                                let nuevoValor = valueToLabelMap[newValue];
                                                setFieldValue('nivelDiesel', nuevoValor);
                                                }}
                                            />
                                            )}
                                        </Field>
                                    </FormControl>
                                </Grid2>
                                )}
                                {(isEditing || (!isDividing && !isMoving)) && (
                                    <Grid2 size={{ xs: 12, sm: 4 }}>
                                        <input
                                            type="file"
                                            accept="application/pdf"
                                            style={{ display: "none" }}
                                            id="upload-pdf-form"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file) {
                                                    setFieldValue('pdf', {
                                                        id: null,
                                                        nombre: file.name,
                                                        file,
                                                        _status: 'new',
                                                    });
                                                }
                                                e.target.value = null; // reset input
                                            }}
                                        />
                                        <label htmlFor="upload-pdf-form">
                                            <Button
                                                variant="outlined"
                                                component="span"
                                                fullWidth
                                                color="secondary"
                                            >
                                                {values.pdf && values.pdf._status !== 'deleted' ? 'Reemplazar PDF' : 'Agregar PDF'}
                                            </Button>
                                        </label>
                                    </Grid2>
                                )}
                                <DialogActions style={{ justifyContent: 'flex-end' }}>
                                    <Button type="submit" disabled={isSubmitting} variant="contained" color="primary">
                                        Guardar
                                    </Button>
                                    <Button onClick={onClose}>Cancelar</Button>
                                </DialogActions>
                            </Grid2>
                        </Form>
                    )}}
                </Formik>
            </DialogContent>
        </Dialog>
    )
}

export default CrearEditarLoves